import axios from 'axios';

const { apiHost = '' } = window.talkrobinConfig || {};
const wootAPI = axios.create({ baseURL: `${apiHost}/` });

export default wootAPI;
